import { createAction, createRequestActions } from "common/helpers/action";

export const setAppReady = createAction("APP.SET_APP_READY");
export const logout = createRequestActions("APP.USER_LOGOUT");
export const selectCompany = createRequestActions("APP.SELECT_COMPANY");

export const setAuthUser = createAction("APP.SET_AUTH_USER");
export const setCollapseMenu = createAction("APP.SET_COLLAPSE_MENU");
